<!--
  - Copyright (c) 2022-2024. Haodong JU
  -->

<template>
  <v-main
    id="pages"
  >
    <div
      class="d-flex"
      style="height: 100%;position: relative;"
    >
      <template>
        <div
          class="hidden-sm-and-down background-container d-flex align-center justify-end"
        >
          <div />
          <v-spacer />
          <v-card
            style="width: 30%;height: 70vh;margin-right: 8%"
            class="hidden-sm-and-down rounded-xxl"
          >
            <router-view />
          </v-card>
        </div>
      </template>

      <div
        class="hidden-md-and-up"
        style="width: 100%"
      >
        <router-view />
      </div>
    </div>
  </v-main>
</template>

<script>

export default {
  name: 'PagesCoreView',
  components: {
  },
  data: () => ({})
}
</script>

<style>
.background-container {
  width: 100%;
  background-image: url('~@/assets/new/backgroundPic/loginPic.png'); /* 使用 ~@ 指向src目录 */
  background-size: cover; /* 确保图片覆盖整个容器 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片平铺 */
}
</style>
